import { render, staticRenderFns } from "./StructuredData.vue?vue&type=template&id=9ffd8918&"
import script from "./StructuredData.vue?vue&type=script&lang=js&"
export * from "./StructuredData.vue?vue&type=script&lang=js&"
import style0 from "./StructuredData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports